import { SalaryComponent } from "./SalaryComponent";
import { SalaryComponentUnit } from "./SalaryComponentUnit";

export class InvalidSalaryComponentError extends Error {
  constructor(
    public readonly component: SalaryComponent,
    public readonly acceptedUnit: SalaryComponentUnit,
  ) {
    super(`Component '${component.name}' is in calculations and does not have a unit of '${acceptedUnit}'`);
    Object.setPrototypeOf(this, InvalidSalaryComponentError.prototype);
  }
}
